import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedHttp } from '../../../../services/http-client.service';
import { ComponentService } from '../../../../services/component.service';
import { SlipModalComponent } from '../../../slip-modal';
import { AuthService } from '../../../../services/auth.service';
import { UtilityService } from '../../../../services/utility.service';
import { WebClientService } from '../../../../services/webclient-settings.service';
import { WebsiteThemeService } from '../../../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
import { LanguageService } from '../../../../services/language.service';
import { BankaccountWhitelistInfoExchangeComponent } from "../../../bankaccount-whitelist-info-exchange/bankaccount-whitelist-info-exchange.component";
/**
 * End Component
 */
let EndBuyComponent = class EndBuyComponent {
    constructor(httpClient, route, router, compService, auth, convertor, webSettingsService, sanitizer, themeService, languageService) {
        this.httpClient = httpClient;
        this.route = route;
        this.router = router;
        this.compService = compService;
        this.auth = auth;
        this.convertor = convertor;
        this.webSettingsService = webSettingsService;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.languageService = languageService;
        this.status = 'registred_user';
        this.userData = {};
        this.outcome = null;
        this.orderId = '';
        this.orderData = null;
        this.textColor = '';
        this.accentColor = '';
        this.successColor = '';
        this.errorColor = '';
        this.linkColor = '';
        this.secondColor = '';
        this.borderRadiusSmaller = '';
        this.paymentButtonColor = '';
        this.orderType = 'buy';
        this.borderRadiusLarger = '';
        this.endData = {};
        this.mainColor = '';
        this.bankAccounts = [];
        this.activeBankAccounts = false;
        this.url = '';
        this.statusApproved = 'APPROVED';
        this.waitingForApprovalStatus = 'WAITING_FOR_APPROVAL';
        this.themeService.getTheme().subscribe((data) => {
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
            this.linkColor = this.themeService.getStyleAttribute('link_color');
            this.paymentButtonColor = this.themeService.getStyleAttribute('payment_button_color');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
        });
        this.userData = JSON.parse(localStorage.getItem('user'));
        this.userType = this.userData.user_type_id.type;
        this.isCompanyUser = this.userData.is_company_user;
        this.status = this.userType + '_user';
        this.isIndividual = this.userData.is_company_user ? 0 : 1;
        this.endData = JSON.parse(localStorage.getItem('draftData'));
        this.currentMeanOfPayment = JSON.parse(localStorage.getItem('currentOrderMeanOfPayment')).verbose_id;
        this.sub = this.route.params.subscribe((params) => {
            this.outcome = params['outcome'];
            this.orderId = params['order_id'];
            this.getOrderData(this.orderId);
        });
        this.languageService.getChosenLanguage().subscribe((lang) => {
            this.lang = lang ? lang : 'en';
        });
        this.url = window.location.href;
    }
    getOrderData(oid) {
        if (oid !== '') {
            this.httpClient.get('market/user/orders/' + oid).subscribe((data) => {
                this.orderData = data;
                if (!('bank_payment_details' in this.orderData)) {
                    this.orderData.bank_payment_details = null;
                }
                this.nameOfCurrency = this.orderData.cryptocurrency;
                this.convertor.convertToShortcut(this.nameOfCurrency).then(result => {
                    this.currency = result + '';
                    this.httpClient.get('market/feesandlimits?ecurrency=' + this.currency + '&mop=' + this.currentMeanOfPayment +
                        '&user_type=' + this.userType + '&order_type=buy' + '&is_individual=' + this.isIndividual + '&chain=' + this.orderData.ecurrency_chain['chain']['name']).subscribe((data) => {
                        this.provision = data['buy'][this.currency][this.currentMeanOfPayment][this.userType].fee;
                    });
                });
            });
        }
    }
    ngOnInit() {
        // this.route.queryParams
        // .filter((params) => params.outcome)
        // .subscribe(params => {
        //   this.outcome = params.outcome;
        //   console.log(this.outcome);
        // });
        this.httpClient.get('user/getbankaccounts').subscribe((result) => {
            this.bankAccounts = result;
            this.bankAccounts = this.bankAccounts.filter(bankAccount => bankAccount.status === this.statusApproved);
        });
    }
    submit() {
    }
    openModal() {
        this.compService.openModal(SlipModalComponent, {
            order_id: +localStorage.getItem('orderId')
        });
    }
    goToTransactions() {
        this.router.navigateByUrl('/transactions');
    }
    openBankAccounts() {
        this.activeBankAccounts = !this.activeBankAccounts;
    }
    addNewBankAccount() {
        this.activeBankAccounts = false;
        this.compService.openModal(BankaccountWhitelistInfoExchangeComponent, {
            pendingProcess: this.bankAccounts.some(account => account.status === this.waitingForApprovalStatus),
        });
    }
};
EndBuyComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: ActivatedRoute },
    { type: Router },
    { type: ComponentService },
    { type: AuthService },
    { type: UtilityService },
    { type: WebClientService },
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: LanguageService }
];
EndBuyComponent = __decorate([
    Component({
        selector: 'ecd-end',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./end.component.html")).default
    })
], EndBuyComponent);
export { EndBuyComponent };
